import { logger } from "./logger-B9q7E6uE.mjs";

export { logger };